import { useQuery } from '@tanstack/react-query';

import { PricingPlanData, getPricingPlans } from '../../api/sales';

interface UsePlanPricesParams<T> {
  select?: (response: PricingPlanData) => T;
  enabled?: boolean;
}

export function usePricingPlans<T = PricingPlanData>({
  select,
  enabled = true,
}: UsePlanPricesParams<T> = {}) {
  return useQuery({
    queryKey: ['pricingPlans'],
    queryFn: getPricingPlans,
    select: select,
    enabled: enabled,
  });
}
